import * as React from 'react'
import { observer } from 'mobx-react'
import HttpActionsService from '../../Services/HttpActionsService'

@observer
export default class OverlayView extends React.Component<any> {

    hs = HttpActionsService.getInstance()

    render() {
        return (
            <div className="overlay" hidden={!this.hs.reqNum}>
                <img className="spinner" src="/images/spinner.png" />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Layout/Overlay.tsx